import {
    RAW_DATA_GET_DEVICE_READING_OPEN_MODAL,
    RAW_DATA_GET_DEVICE_READING_REQUEST,
    RAW_DATA_GET_DEVICE_READING_RESULT,
} from 'Redux/actionTypes';

export const getDeviceReadingOpenModal = (open, filters) => ({
    type: RAW_DATA_GET_DEVICE_READING_OPEN_MODAL,
    payload: { open, filters }
})

export const getDeviceReadingRequest = (data) => ({
    type: RAW_DATA_GET_DEVICE_READING_REQUEST,
    payload: data
})

export const getDeviceReadingResult = (data) => ({
    type: RAW_DATA_GET_DEVICE_READING_RESULT,
    payload: data
})